import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { ToastrService } from 'ngx-toastr';
import { HeaderComponent } from 'src/app/components/header/header.component';
import { Applicant } from 'src/app/models/applicant.model';
import { ApplicantService } from 'src/app/services/applicant/applicant.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { Md5 } from 'ts-md5';


@Component({
  selector: 'gabarito-recover-password',
  templateUrl: './recover-password.component.html',
  styleUrls: ['./recover-password.component.scss']
})
export class RecoverPasswordComponent implements OnInit {

  faSpinner = faSpinner;

  token;
  applicant: Applicant;
  errorMsg;
  invalidToken = false;
  name;

  form: FormGroup;
  password: FormControl;
  confirmPassword: FormControl;
  showError = false;
  resultError = '';
  loading = false;
  confirmPasswordNotSameError = false;
  confirmPasswordRequiredError = false;

  constructor(private route: ActivatedRoute, private service: ApplicantService, private authService: AuthService, private router: Router,
              private toastr: ToastrService) {}

  ngOnInit() {
    this.token = this.route.snapshot.paramMap.get('token');

    this.password = new FormControl(undefined, [Validators.required, Validators.minLength(6), Validators.maxLength(15)]);
    this.confirmPassword = new FormControl(undefined);

    this.form = new FormGroup({
      password: this.password,
      confirmPassword: this.confirmPassword,
    });

    this.service.verifyToken(this.token).subscribe(
      response => {
        this.applicant = response;
        this.name = this.applicant.name;
      },
      error => {
        this.invalidToken = true;
      }
    );

    this.authService.loginSuccess.subscribe(
      () => {
        this.toastr.success('Senha alterada com sucesso!', '', {
          positionClass: 'toast-bottom-right'
        });
        // this.loading = false;
        this.router.navigate(['/applicant/dashboard']);
      }
    );

    this.authService.loginFail.subscribe(
      (error: any) => {
        this.showError = true;
        this.errorMsg = 'Erro inesperado, tente mais tarde';
        console.log(error);
        this.loading = false;
      }
    );

  }

  confirmPasswordValidation() {
    if (this.confirmPassword.value === undefined || this.confirmPassword.value === null || this.confirmPassword.value === '') {
      this.confirmPasswordRequiredError = true;
      this.confirmPasswordNotSameError = false;
    } else {
      this.confirmPasswordRequiredError = false;

      if (this.confirmPassword.value === this.password.value) {
        this.confirmPasswordNotSameError = false;
      } else {
        this.confirmPasswordNotSameError = true;
      }
    }
  }

  submitChangePassword() {
    this.showError = false;
    this.confirmPasswordValidation();
    if (this.form.valid && !this.confirmPasswordNotSameError && !this.confirmPasswordRequiredError) {
      this.changePassword();
    } else {
      this.showError = true;
    }
  }

  changePassword() {
    this.loading = true;
    const md5 = new Md5();
    this.applicant.password = md5.appendStr(this.form.value.password).end() as string;

    this.service.changePassword(this.token, this.applicant).subscribe(
      () => {
        this.authService.applicantSignin(this.applicant);
      },
      error => {
        this.invalidToken = true;
      }
    );
  }

  home() {
    this.router.navigate(['/']);
  }

}
